import extendUserPreferences from './User/extendUserPreferences';
export default function () {
  extendUserPreferences();
}